import React from 'react';
import { Global } from '@emotion/react';
import top from '@/assets/bet777/images/background/bg.png';

export default function index() {
  return (
    <Global
      styles={{
        body: {
          backgroundImage: `url(${top}), linear-gradient(180deg, #350474 0%, #2B045C 100%);`,
          backgroundPosition: 'top, center',
          backgroundRepeat: 'repeat',
          backgroundSize: '100vw',
          backgroundAttachment: 'fixed',
          '@media (max-width: 767px)': {
            background: `linear-gradient(180deg, var(--bc-colors-alpha-700), var(--bc-colors-alpha-800))`,
          },
        },
      }}
    />
  );
}
